import { cn } from "../lib/cn";

export interface SkeletonProps {
	width?: number | string;
	height?: number | string;
	/** Круглый плейсхолдер под аватар: ширина берётся из высоты. */
	circle?: boolean;
	radius?: "chip" | "control" | "card" | "full";
	className?: string;
}

const RADIUS = {
	chip: "rounded-chip",
	control: "rounded-control",
	card: "rounded-card",
	full: "rounded-full",
} as const;

/**
 * Серая плашка с 2.4s дыханием. Скелетон повторяет форму контента, а не
 * заменяет его прямоугольником: список, загруженный поверх скелетона другой
 * геометрии, прыгает.
 */
export function Skeleton({
	width = "100%",
	height = 18,
	circle = false,
	radius = "chip",
	className,
}: SkeletonProps) {
	return (
		<span
			aria-hidden="true"
			className={cn(
				"block shrink-0 bg-sunken",
				circle ? "rounded-full" : RADIUS[radius],
				className,
			)}
			style={{
				width: circle ? height : width,
				height,
				animation: "iec-shimmer 2.4s var(--ease-smooth) infinite",
			}}
		/>
	);
}

export interface TextSkeletonProps {
	/** Ширины строк в процентах — так же, как это делает продукт. */
	lines?: readonly number[];
	size?: "sm" | "md" | "lg";
	className?: string;
}

export function TextSkeleton({ lines = [100, 92, 64], size = "sm", className }: TextSkeletonProps) {
	const height = size === "lg" ? 32 : size === "md" ? 24 : 18;
	const gap = size === "lg" ? "gap-2" : size === "md" ? "gap-1.5" : "gap-1";
	return (
		<span className={cn("flex w-full flex-col", gap, className)}>
			{lines.map((width, index) => (
				<Skeleton key={index} width={`${width}%`} height={height} />
			))}
		</span>
	);
}
